(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    // "See the size on the wall" and "Read more about the materials" open the matching panel
  // inside the Bozetto product tabs block. One listener for both: the link names its own
  // panel in data-guide-target, so a third guide needs markup only, no new script.
  // When the link has a custom URL (no matching #pt-<id> target) it behaves as a normal link.
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('[data-guide-link]') : null;
    if (!link) return;

    const hash = link.hash || '';
    if (!hash.startsWith('#pt-')) return;

    // Only intercept when the guide is on this page; from the quick-add modal the link navigates.
    const tabs = document.getElementById(hash.slice(1));
    const target = link.dataset.guideTarget || 'size';
    const trigger = tabs?.querySelector(`.bzg-item[data-target="${target}"]`);
    if (!trigger) return;

    event.preventDefault();
    if (trigger.getAttribute('aria-expanded') !== 'true') trigger.click();
    tabs.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  } catch(e) { console.error(e); }
})();

})();
